import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import ReactTable from 'react-table'
import { actions } from '../../redux/modules/itemsActions'
import { actions as jobVendorActions } from '../../redux/modules/jobFunctions/jobVendorActions'
import { actions as organizationsActions } from '../../redux/modules/organizationsActions'
import { actions as jobs } from '../../redux/modules/jobs'
import { actions as employeesActions } from '../../redux/modules/employeesActions'
import ItemVendors from '../../components/item/ItemVendors'
import moment from 'moment'
import numeral from 'numeral'
import CurrencyInput from 'react-currency-input'
import CustomTypeahead from './CustomTypeahead'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  Select,
  InputNumber,
  AutoComplete,
  Icon,
  //Upload,
  message,
  Tooltip
} from 'antd'
//import ImageBrowser from './ImageBrowser'
import PicturesWall from './PictureWall'
import { convertToOptionId, filterCaseInsensitive } from '../../util'
import PaginationComponent from '../../components/PaginationComponent'
import styled from 'styled-components'
import Notes from '../../components/notes/Notes'
import _ from 'lodash'
import OrganizationQuickAdd from '../../components/organization//OrganizationQuickAdd'

const StyledActionContainer = styled.div`
  display: flex;
`

const FormItem = Form.Item
const { TextArea } = Input
const Option = Select.Option

const propTypes = {}

class Items extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      content: null,
      filtered: [],
      selectedFilesList: null,
      selectedJob: [],
      jobValidationMessage: null
    }

    this.props.itemsRefresh()
    this.props.getAllVendors()
    this.props.jobsRefresh({})
    this.props.employeesRefresh()
  }

  handleAddButton = () => {
    this.props.form.resetFields()
    this.setState({
      modalVisible: true,
      content: null,
      selectedFilesList: []
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({
      data: [],
      currentId: null,
      modalVisible: false,
      selectedFilesList: null,
      selectedJob: [],
      jobValidationMessage: null
    })
  }

  getSelectedJob = () => {
    const { selectedJob } = this.state
    return selectedJob !== null && selectedJob.length > 0 ? selectedJob[0].id : null
  }

  getSelectedEmployee = value => {
    const employees =
      this.props.employeesActions &&
      this.props.employeesActions.payload &&
      this.props.employeesActions.payload.data
    const selectedEmployee = employees.find(
      employee => `${employee.first_name} ${employee.last_name}` === value
    )
    return selectedEmployee ? +selectedEmployee.id : +value
  }

  getSelectedOrganization = value => {
    const vendors = _.get(this.props, 'jobVendorActions.allVendors.data')
    const selectedVendor = vendors.find(vendor => vendor.name === value)
    return selectedVendor ? +selectedVendor.id : +value
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      // percentages convert
      values.overhead = values.overhead / 100
      values.markup = values.markup / 100

      // sanitize
      values.job_id = this.getSelectedJob()
      values.employee_id =
        this.getSelectedEmployee(values.employee_id) != 0
          ? this.getSelectedEmployee(values.employee_id)
          : null
      values.cost =
        values.cost && typeof values.cost === 'string'
          ? values.cost.replace(/(\$|,)/g, '')
          : values.cost

      if (!this.state.currentId) {
        this.props.createNewItem({
          item: values,
          userId: this.props.authentication.user.userId,
          fileList: this.state.selectedFilesList
        })
      } else {
        this.props.updateSavedItem({
          itemId: this.state.currentId,
          item: values,
          userId: this.props.authentication.user.userId,
          fileList: this.state.selectedFilesList
        })
      }
      form.resetFields()
      message.warning('Item created.')
      this.setState({
        content: null,
        currentId: null,
        modalVisible: false,
        selectedFilesList: null
      })
    })
  }

  uploadImage = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'item')
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('itemId', this.state.currentId)
    formData.append('userId', this.props.authentication.user.userId)

    this.props.saveItemImage({
      image: formData,
      itemId: this.state.currentId
    })
  }

  handleDeleteImage = imageId => {
    this.props.deleteItemImage({
      imageId: imageId,
      itemId: this.state.currentId
    })
  }

  handleInputChange = input => {
    const { form } = this.props
    if (input === '') {
      this.setState(
        {
          selectedJob: []
        },
        () => {
          form.resetFields(['job_id'])
          form.validateFields()
        }
      )
    }
  }

  handleRowClick = row => {
    const jobs = _.get(this.props, 'jobs.payload.data')
    let j = jobs.find(j => row.job_id === j.id)
    if (_.isObject(j)) {
      j = [
        {
          id: j.id,
          label: j.name
        }
      ]
    } else {
      j = []
    }
    this.setState({
      modalVisible: true,
      currentId: row.id,
      content: row,
      selectedFilesList: null,
      selectedJob: j
    })
    this.props.getItemImages({
      itemId: row.id
    })

    this.props.getItemVendors({
      itemId: row.id
    })

    this.props.getItemNote({ itemId: row.id })
  }

  handleDeleteItem = () => {
    const form = this.props.form
    this.props.deleteItem({
      itemId: this.state.currentId
    })
    form.resetFields()
    message.warning('Item deleted.')
    this.setState({ content: null, currentId: null, modalVisible: false })
  }

  handlePrintAll = () => {
    let queryString = ''
    let needsAmpersand = false
    this.state.filtered
      .filter(f => f.id !== 'type' && f.value.toLowerCase() !== 'all')
      .forEach((filter, index) => {
        needsAmpersand = true
        const separator = index === 0 ? '?' : '&'
        queryString += `${separator}${filter.id}=${filter.value}`
      })

    const { email } = this.props.authentication.user

    if (needsAmpersand) {
      queryString += `&email=${email}`
    } else {
      queryString += `?email=${email}`
    }

    this.props.printItems(queryString)
    message.success(`An email will be sent to you to ${email} with the list of items included`)
  }

  typeValidator = (rule, value, callback) => {
    const form = this.props.form
    form.validateFields(['job_id', 'employee_id'], { force: true })
    callback()
  }

  handleOnChangeJob = option => {
    const { form } = this.props
    this.setState(
      {
        selectedJob: option
      },
      () => {
        form.validateFields(['job_id'], { force: true })
      }
    )
  }

  jobValidation = (rule, value, callback) => {
    const form = this.props.form
    const typeVal = form.getFieldValue('type')
    if (!value && typeVal === 'Tool') {
      const message = 'Job is required for Tools'
      this.setState({ jobValidationMessage: message })
      callback(message)
    } else {
      this.setState({ jobValidationMessage: null })
      callback()
    }
  }

  employeeValidation = (rule, value, callback) => {
    const form = this.props.form
    const typeVal = form.getFieldValue('type')
    if ((!value || value === 0) && typeVal === 'Tool') {
      callback('Employee is required for Tools')
    } else {
      callback()
    }
  }

  handleCreateItemVendor = values => {
    this.props.createItemVendor({ itemVendorPayload: values })
  }

  deleteItemVendor = itemVendorPayload => {
    this.props.deleteItemVendor({ itemVendorPayload: itemVendorPayload })
  }

  // notes things
  handleToggleNoteEditArea = () => {
    if (this.state.currentNote) {
      this.setState({
        currentNote: null,
        currentNoteId: null,
        noteAddEditContainer: true
      })
    } else {
      this.setState({
        noteAddEditContainer: !this.state.noteAddEditContainer
      })
    }
  }

  createNote = params => {
    this.props.createItemNote({
      content: params,
      userId: this.props.authentication.userId,
      itemId: this.state.currentId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editItemNote({
      content: params,
      noteId: this.state.currentNoteId,
      itemId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteItemNote({
      noteId: this.state.currentNoteId,
      itemId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  handleVendorsMultiselect = () => {
    const vendors =
      this.props.jobVendorActions &&
      this.props.jobVendorActions.allVendors &&
      this.props.jobVendorActions.allVendors.data
    let options = []
    if (vendors) {
      for (const vendor of vendors) {
        options.push(<Option key={vendor.id}>{vendor.name}</Option>)
      }
    }
    return options
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.authentication.user.userId
    })
    setTimeout(() => {
      this.props.getAllVendors()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.jobVendorActions.allVendors.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.jobVendorActions.allVendors.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  onFileListChange = fileList => {
    this.setState(prevState => ({
      selectedFilesList: fileList
    }))
  }
  /* End Organization Quick Add */
  formatItemImages = props => {
    const itemImages = _.get(this.props, 'itemsActions.itemImages.data')
    if (itemImages) {
      return itemImages.map(img => {
        return {
          uid: img.id,
          name: img.filename,
          status: 'done',
          url: img.signedUrl,
          ...img
        }
      })
    }
  }
  render() {
    const { content } = this.state
    const { getFieldDecorator } = this.props.form
    const { payload } = this.props.itemsActions
    const employees = _.get(this.props, 'employeesActions.payload.data')
    if (!payload || !employees) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      const allVendors = _.get(this.props, 'jobVendorActions.allVendors.data')
      const itemImages = this.formatItemImages()
      const itemsVendors = _.get(this.props, 'itemsActions.itemsVendors.data')
      const jobs = _.get(this.props, 'jobs.payload.data')

      const employeesOptions = employees.map(d => (
        <Option key={d.id}>{`${d.first_name} ${d.last_name}`}</Option>
      ))

      return (
        <div>
          <OrganizationQuickAdd
            modalVisible={this.state.quickAddModalVisibility}
            handleCancel={this.handleCancelQuickAdd}
            handleQuickAddOrganization={this.handleQuickAddOrganization}
            organizartionType={'Vendor'}
          />
          <Modal
            visible={this.state.modalVisible}
            title="Item"
            okText={content ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancel}
            onOk={this.handleCreate}
            width={'90%'}
            maskClosable={false}
          >
            <Form layout="vertical">
              {content && (
                <div className="row" style={{ marginBottom: '15px', marginTop: '15px' }}>
                  <div className="col-md-3">
                    Created by:
                    <strong>{` ${content.created_by_first_name} ${
                      content.created_by_last_name
                    }`}</strong>
                  </div>
                  <div className="col-md-3">
                    Updated by:
                    <strong>{` ${content.updated_by_first_name} ${
                      content.updated_by_last_name
                    }`}</strong>
                  </div>
                  <div className="col-md-3">
                    Created date:{' '}
                    <strong>{moment.utc(content.created_date).format('M/D/YYYY')}</strong>
                  </div>
                  <div className="col-md-3">
                    Updated date:{' '}
                    <strong>{moment.utc(content.updated_date).format('M/D/YYYY')}</strong>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Name">
                    {getFieldDecorator('name', {
                      rules: [
                        {
                          required: true,
                          message: 'Name cannot be blank.'
                        }
                      ],
                      initialValue: content ? content.name : ''
                    })(<Input placeholder="Type the Item name..." />)}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  {!content && (
                    <FormItem label="Vendors">
                      {getFieldDecorator('vendors', {})(
                        <Select
                          mode="multiple"
                          style={{ width: '100%' }}
                          placeholder="Please select the vendors"
                          onBlur={this.handleBlurOrganization}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        >
                          {this.handleVendorsMultiselect()}
                        </Select>
                      )}
                    </FormItem>
                  )}
                  {
                    <PicturesWall
                      onFileListChange={this.onFileListChange}
                      selectedFilesList={this.state.selectedFilesList || itemImages}
                      handleDeleteImage={this.handleDeleteImage}
                    />
                  }
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <FormItem label="Type">
                    {getFieldDecorator('type', {
                      rules: [
                        {
                          required: true,
                          message: 'Name cannot be blank.'
                        },
                        {
                          validator: this.typeValidator
                        }
                      ],
                      initialValue: content ? content.type : 'Product'
                    })(
                      <Select>
                        <Option value="Product">Product</Option>
                        <Option value="Labor">Labor</Option>
                        <Option value="Group">Group</Option>
                        <Option value="Service">Service</Option>
                        <Option value="Material">Material</Option>
                        <Option value="Other Charge">Other Charge</Option>
                        <Option value="Sales Tax Item">Sales Tax Item</Option>
                        <Option value="Tool">Tool</Option>
                      </Select>
                    )}
                  </FormItem>
                </div>
                <div className="col-md-4">
                  <FormItem label="Job">
                    {getFieldDecorator('job_id', {
                      rules: [
                        {
                          required: false,
                          message: 'Job cannot be blank.'
                        },
                        {
                          validator: this.jobValidation
                        }
                      ],
                      initialValue: content ? content.job_name : null
                    })(
                      <CustomTypeahead
                        options={convertToOptionId(jobs)}
                        maxVisible={2}
                        selected={this.state.selectedJob}
                        onChange={this.handleOnChangeJob}
                        onInputChange={this.handleInputChange}
                        placeholder="Search for a job"
                        validationMessage={this.state.jobValidationMessage}
                      />
                    )}
                  </FormItem>
                </div>
                <div className="col-md-4">
                  <FormItem label="Employee using tool">
                    {getFieldDecorator('employee_id', {
                      rules: [
                        {
                          required: false,
                          message: 'Employee using tool cannot be blank.'
                        },
                        {
                          validator: this.employeeValidation
                        }
                      ],
                      initialValue:
                        content && content.employee_first_name
                          ? `${content.employee_first_name} ${content.employee_last_name}`
                          : null
                    })(
                      <AutoComplete
                        dataSource={employeesOptions}
                        filterOption={(inputValue, option) =>
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        }
                        placeholder="Search for an Employee"
                        width={320}
                      >
                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                      </AutoComplete>
                    )}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <FormItem label="Cost">
                    {getFieldDecorator('cost', {
                      initialValue: content ? content.cost : 0
                    })(
                      <CurrencyInput
                        className="ant-input"
                        precision="2"
                        prefix="$"
                        placeholder="Enter purchased miles..."
                      />
                    )}
                  </FormItem>
                </div>
                <div className="col-md-4">
                  <FormItem label="Overhead (%)">
                    {getFieldDecorator('overhead', {
                      initialValue: content ? content.overhead * 100 : 0
                    })(<InputNumber formatter={value => `${value}%`} />)}
                  </FormItem>
                </div>
                <div className="col-md-4">
                  <FormItem label="Mark Up (%)">
                    {getFieldDecorator('markup', {
                      initialValue: content ? content.markup * 100 : 0
                    })(<InputNumber formatter={value => `${value}%`} />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Description">
                    {getFieldDecorator('description', {
                      initialValue: content ? content.description : ''
                    })(<TextArea rows={4} />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Internal Description">
                    {getFieldDecorator('internal_description', {
                      initialValue: content ? content.internal_description : ''
                    })(<TextArea rows={4} />)}
                  </FormItem>
                </div>
              </div>
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={this.handleDeleteItem}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                {content && <Button type="danger" icon="delete" />}
              </Popconfirm>
            </Form>
            {this.state.currentId && (
              <div className="row">
                <div className="col-6">
                  <ItemVendors
                    itemsVendors={itemsVendors}
                    handleCancel={this.handleCancelQuickAdd}
                    handleQuickAddOrganization={this.handleQuickAddOrganization}
                    allVendors={allVendors}
                    handleCreateItemVendor={this.handleCreateItemVendor}
                    userId={this.props.authentication.user.userId}
                    itemId={this.state.currentId}
                    deleteItemVendor={this.deleteItemVendor}
                  />
                </div>
                <div className="col-6">
                  <Notes
                    // notes props
                    currentNote={this.state.currentNote}
                    currentNoteId={this.state.currentNoteId}
                    notes={
                      this.props.itemsActions.itemNotes && this.props.itemsActions.itemNotes.data
                    }
                    handleToggleNoteEditArea={this.handleToggleNoteEditArea}
                    noteAddEditContainer={this.state.noteAddEditContainer}
                    createNote={this.createNote}
                    handleRowNoteClick={this.handleRowNoteClick}
                    updateNote={this.updateNote}
                    userId={this.props.authentication.user.userId}
                    deleteNote={this.deleteNote}
                  />
                </div>
              </div>
            )}
          </Modal>
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/items">Items</Link>
                </li>
              </ol>
            </nav>
            <h2>Items</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Items
                <StyledActionContainer>
                  <div className="jobsBarAdd">
                    <i className="fa fa-print" aria-hidden="true" />
                    &nbsp;
                    <div onClick={() => this.handlePrintAll()} className="addJobLabel">
                      PRINT ALL
                    </div>
                  </div>
                  <div className="jobsBarAdd">
                    <i className="fa fa-plus-square" aria-hidden="true" />
                    &nbsp;
                    <div onClick={() => this.handleAddButton()} className="addJobLabel">
                      NEW ITEM
                    </div>
                  </div>
                </StyledActionContainer>
              </div>
              <ReactTable
                data={payload.data}
                getTdProps={(state, rowInfo, column, instance) => ({
                  onClick: e => {
                    if (column.Header !== undefined) {
                      this.handleRowClick(rowInfo.original)
                    }
                  }
                })}
                filterable
                filtered={this.state.filtered}
                onFilteredChange={filtered => {
                  this.setState({ filtered })
                }}
                defaultFilterMethod={filterCaseInsensitive}
                PaginationComponent={PaginationComponent}
                ref={r => (this.selectTable = r)}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Name',
                        id: 'name',
                        accessor: 'name',
                        minWidth: 200,
                        Cell: props => {
                          return (
                            <Tooltip title={props.original.name}> {props.original.name} </Tooltip>
                          )
                        }
                      },
                      {
                        Header: 'Type',
                        id: 'type',
                        accessor: 'type',
                        Cell: d => <Tooltip title={d.original.type}>{d.original.type}</Tooltip>,
                        minWidth: 110,
                        filterMethod: (filter, row) => {
                          if (filter.value === 'all') return true
                          return filter.value === row.type
                        },
                        Filter: ({ filter, onChange }) => (
                          <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: '100%' }}
                            value={filter ? filter.value : 'all'}
                          >
                            <option value="all">All</option>
                            <option value="Product">Product</option>
                            <option value="Labor">Labor</option>
                            <option value="Group">Group</option>
                            <option value="Service">Service</option>
                            <option value="Material">Material</option>
                            <option value="Other Charge">Other Charge</option>
                            <option value="Sales Tax Item">Sales Tax Item</option>
                            <option value="Tool">Tool</option>
                          </select>
                        )
                      },
                      {
                        Header: 'Cost',
                        id: 'cost',
                        accessor: 'cost',
                        Cell: d => {
                          return (
                            <Tooltip title={numeral(d.original.cost).format('$0,0.00')}>
                              {numeral(d.original.cost).format('$0,0.00')}
                            </Tooltip>
                          )
                        },
                        minWidth: 60,
                        filterable: false
                      },
                      {
                        Header: 'Overhead',
                        id: 'overhead',
                        accessor: 'overhead',
                        Cell: d => {
                          return (
                            <Tooltip title={`${d.original.overhead * 100} %`}>
                              {d.original.overhead * 100} %
                            </Tooltip>
                          )
                        },
                        minWidth: 60,
                        filterable: false
                      },
                      {
                        Header: 'Markup',
                        id: 'markup',
                        accessor: 'markup',
                        Cell: d => {
                          return (
                            <Tooltip
                              title={
                                d.original.markup
                                  ? `${numeral(d.original.markup * 100).format('0')} %`
                                  : 'N/A'
                              }
                            >
                              {d.original.markup
                                ? `${numeral(d.original.markup * 100).format('0')} %`
                                : 'N/A'}
                            </Tooltip>
                          )
                        },
                        minWidth: 60,
                        filterable: false
                      },
                      {
                        Header: 'Created Date',
                        id: 'created_date',
                        accessor: 'created_date',
                        Cell: row => (
                          <Tooltip title={moment.utc(row.value).format('M/D/YYYY')}>
                            {moment.utc(row.value).format('M/D/YYYY')}
                          </Tooltip>
                        ),
                        minWidth: 70,
                        filterable: false
                      },
                      {
                        Header: 'Updated Date',
                        id: 'updated_date',
                        accessor: 'updated_date',
                        Cell: row => (
                          <Tooltip title={moment.utc(row.value).format('M/D/YYYY')}>
                            {moment.utc(row.value).format('M/D/YYYY')}
                          </Tooltip>
                        ),
                        minWidth: 70,
                        filterable: false
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (
  { itemsActions, jobVendorActions, organizationsActions, jobs, employeesActions, authentication },
  ownProps
) => ({
  itemsActions,
  jobVendorActions,
  organizationsActions,
  jobs,
  employeesActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, actions, jobVendorActions, organizationsActions, jobs, employeesActions),
    dispatch
  )
})

Items.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(Items)))



// WEBPACK FOOTER //
// ./src/containers/items/index.js